import React from 'react';
import { Stack } from '../../design-system/stack/stack';
import Header from '../layout/header';
import ConsentSettings from './consent-settings';

const OrganisationSettingsPage: React.FC = () => {
  return (
    <Stack align="stretch" className="min-h-full flex-1 p-2.5">
      <div className="flex-1 rounded-lg bg-white">
        <Header>
          <div className="w-full pb-4">
            <h1 className="text-2xl font-semibold text-gray-900">Organisation Settings</h1>
            <p className="mt-1 text-sm text-gray-500">Manage your data sharing consents with third-party providers.</p>
          </div>
        </Header>

        <ConsentSettings />
      </div>
    </Stack>
  );
};

export default OrganisationSettingsPage;
